import { formatNumber } from '../../utils/formatters';

export default function MetricBreakdownTable({ title, data, columns }) {
  if (!data || data.length === 0) {
    return (
      <div className="card">
        <h3 className="text-sm font-semibold text-gray-300 mb-3">{title}</h3>
        <p className="text-gray-500 text-sm">No data available</p>
      </div>
    );
  }

  return (
    <div className="card">
      <h3 className="text-sm font-semibold text-gray-300 mb-3">{title}</h3>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr>
              {columns.map(col => (
                <th key={col.key} className="table-header text-left py-2 px-3">{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={i} className="border-b border-surface-700 hover:bg-surface-700/50">
                {columns.map(col => (
                  <td key={col.key} className="py-2.5 px-3 text-sm text-gray-300">
                    {col.render ? col.render(row[col.key], row) : (
                      typeof row[col.key] === 'number' ? formatNumber(row[col.key]) : (row[col.key] ?? 'N/A')
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
